module.exports = __webpack_public_path__ + "static/media/timetable.c03538c3.svg";